var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('users-list',{attrs:{"add-request-path":_vm.requestUrls.admin.add,"edit-request-path":_vm.requestUrls.admin.edit,"role-query":"Admin","edit-fields":_vm.fields,"registration-fields":_vm.fields}})}
var staticRenderFns = []

export { render, staticRenderFns }